import { ToastService } from './toast.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastNotificationModel } from './toast.model';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

  notifications: ToastNotificationModel[] = [];

  constructor(private notificationService: ToastService,
    private cdRef: ChangeDetectorRef,
    ) { }

  ngOnInit() {
    this.notificationService.getAlert().subscribe((alert: ToastNotificationModel) => {
      this.notifications = [];
      if (!alert) {
        this.notifications = [];
        return;
      }
      this.notifications.push(alert);
      setTimeout(() => {
        this.notifications = this.notifications.filter(x => {x !== alert});
        this.cdRef.markForCheck();
      }, 5000);
    });
  }

  removeNotification(notification: ToastNotificationModel) {
    this.notifications = this.notifications.filter(x => x !== notification);
  }

  /**Set css class for Alert -- Called from alert component**/
  cssClass(notification: ToastNotificationModel) {
    if (!notification) {
      return;
    }
    switch (notification.type) {
      case 'Success':
        return 'toast-success';
      case 'Error':
        return 'toast-error';
      case 'Info':
        return 'toast-info';
      case 'Warning':
        return 'toast-warning';
    }
  }

}
